// The auth layout (FR-042, FR-047; research R14), in the Akaiva sign-in frame shared with the admin
// console and the driver app (constitution 1.1.0): the card on the backdrop holds the heading as on
// the admin console's sign-in (bold, 32 px, sentence case), an optional line under it, and the
// screen; the welcome line beside the card is the screen's `intro`.
import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import {
  AUTH_FRAME_MAX_WIDTH,
  AuthFrame,
  type AuthIntro,
} from "@/shell/authFrame/AuthFrame";
import { makeStyles } from "@/theme/makeStyles";
import { Text } from "@/ui/Text";

/** The card's maximum width (the shared sign-in frame). */
export const AUTH_CARD_MAX_WIDTH = AUTH_FRAME_MAX_WIDTH;

const useStyles = makeStyles((t) =>
  StyleSheet.create({ heading: { gap: t.space.sm } }),
);

export type AuthCardProps = {
  title: string;
  /** A line under the heading. */
  subtitle?: string;
  /** The welcome line beside the card. */
  intro?: AuthIntro;
  children: ReactNode;
  testID?: string;
};

export function AuthCard({
  title,
  subtitle,
  intro,
  children,
  testID,
}: AuthCardProps) {
  const styles = useStyles();
  return (
    <AuthFrame intro={intro} testID={testID}>
      <View style={styles.heading}>
        <Text
          variant="heading"
          size="x5l"
          accessibilityRole="header"
          aria-level={1}
        >
          {title}
        </Text>
        {subtitle ? (
          <Text tone="muted" size="lg">
            {subtitle}
          </Text>
        ) : null}
      </View>
      {children}
    </AuthFrame>
  );
}
